import React from 'react';
import Collapse from '../../../../Components/HealthPlan/Collapse/Collapse';
import Table from '../../../../Components/Table/Table';
import Loading from '../../../../Components/Loading';
import { ITableColumn } from '../../../../Models/Table/ITableColumn';
import ScrollableDataTable from '../../../Base/Components/ScrollableDataTable/ScrollableDataTable';

export interface HealthDataBaseTableProps {
	title?: string;
	rows: any[];
	columns: ITableColumn[];
	isLoading: boolean;
}

const HealthDataBaseTable: React.FC<HealthDataBaseTableProps> = props => {
	const { title, rows, columns, isLoading } = props;
	return (
		<Collapse title={title} defaultOpen>
			{isLoading ? (
				<Loading />
			) : (
				<ScrollableDataTable columns={columns} rows={rows} />
			)}
		</Collapse>
	);
};

export default HealthDataBaseTable;
